export default __webpack_public_path__ + "static/media/arif-doc-new.ff110034.jpg";